/* eslint-disable import/prefer-default-export */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EnochQueryKeys } from 'query/enoch';
import { showSuccessNotification } from 'services/common';
import {
  runEnochJob,
  saveEnochConfig,
  terminateEnochJob,
} from 'services/enoch';

export const useSaveEnochConfig = () => {
  const queryClient = useQueryClient();
  return useMutation(saveEnochConfig, {
    onSuccess: async () => {
      queryClient
        .invalidateQueries([EnochQueryKeys.enochConfig])
        .then(() => {});
      showSuccessNotification('Enoch config saved successfully');
    },
  });
};

export const useTerminateEnochJob = () => {
  return useMutation(terminateEnochJob, {
    onSuccess: () => {
      showSuccessNotification(
        'Request to terminate enoch job sent successfully',
      );
    },
  });
};

export const useRunEnochJob = () => {
  return useMutation(runEnochJob, {
    onSuccess: () => {
      showSuccessNotification('Request to start enoch job sent successfully');
    },
  });
};
